import { define } from '../../define.js';
import { Carousel } from './carousel.js';
export * from './carousel.js';
define('carousel', Carousel);
